<script>
import { mapActions, mapState } from "vuex";
import cryptoRandomString from "crypto-random-string";
import compUmat from "@/components/form/umat";
import compUmatKomuni from "@/components/form/komuni";
import compUmatModal from "@/components/modal/umat";
import umatOpt from "@/data/umatOpt";

export default {
	name: "komuniForm",
	components: {
		"comp-umat": compUmat,
		"comp-umat-komuni": compUmatKomuni,
		"comp-umat-modal": compUmatModal,
	},
	data() {
		return {
			mode: "INSERT",
			uid: "",
			myOptions: {
				kriteria: umatOpt.kriteria,
				jk: umatOpt.jk,
				gol_darah: umatOpt.golDarah,
			},
			trigger: {
				umat: 0,
				komuni: 0,
			},
		};
	},
	computed: {
		isLoading() {
			return this.$store.state.isLoading;
		},
		...mapState({
			umatItem: (state) => state.umat.item,
			umatKomuniItem: (state) => state.umatKomuni.item,
			lingkunganStasi: (state) => state.service.lingkunganStasi,
		}),
	},
	created() {
		this.$store.dispatch("umat/resetItem");
		this.$store.dispatch("umatKomuni/resetItem");

		this.uid = cryptoRandomString({
			length: 32,
			type: "distinguishable",
		});

		this.umatItem.uid = this.uid;
		this.umatKomuniItem.uid = this.uid;

		if (typeof this.$route.params.id !== "undefined") {
			this.mode = "UPDATE";

			this.getItemKomuni(this.$route.params.id).then(
				(response) => {

					this.setItemUmat(response.data.umat);
					this.setItemKomuni(response.data.komuni);
				},
				() => {
					this.$router.push("/komuni");
				}
			);
		} else {
			this.$swal({
				title: "Apakah umat baru atau lama?",
				text: "",
				icon: "warning",
				showCancelButton: true,
				confirmButtonText: "Lama",
				cancelButtonText: "Baru",
				html: false,
				allowOutsideClick: false,
				preConfirm: () => {
					this.$modal.show("umatModal");
				},
			}).then((result) => {
				if (typeof result.dismiss !== "undefined") {
					if (result.dismiss == "cancel") {
						// this.autoFill();
					}
				}
			});
		}
	},
	mounted() {
		this.getLingkunganStasi();
	},
	methods: {
		...mapActions({
			insert: "umatKomuni/insert",
			update: "umatKomuni/update",
			getItemKomuni: "umatKomuni/getItem",
			setItemKomuni: "umatKomuni/setItem",
			setItemUmat: "umat/setItemForm",
			getItemUmat: "umat/getItem",
			getLingkunganStasi: "service/getLingkunganStasi",
		}),
		handleSumbmit() {
			this.trigger.umat = !this.trigger.umat;
		},
		async validateUmat(result) {
			await result.then((valid) => {
				if (!valid) {
					this.$toast.error("Identitas Umat belum lengkap");
				} else {
					this.trigger.komuni = !this.trigger.komuni;
				}
			});
		},
		async validateKomuni(result) {
			await result.then((valid) => {
				if (!valid) {
					this.$toast.error("Data Komuni belum lengkap");
				} else {
					this.onSubmit();
				}
			});
		},
		onSubmit() {
			const data = {
				umat: this.umatItem,
				komuni: this.umatKomuniItem,
			};

			if (this.mode === "INSERT") {
				this.insert(data).then(() => {
					this.$router.push("/komuni");
				});
			} else {
				this.update(data).then(() => {
					this.$router.push("/komuni");
				});
			}
		},
		onCancel() {
			this.$router.push("/komuni");
		},
		onRowClick(uid) {
			this.getItemUmat(uid).then((response) => {
				const umat = response.data.umat;

				if (umat.is_komuni) {
					this.$toast.error("Umat ini sudah komuni");
					return;
				}

				this.setItemUmat(umat);
				this.umatKomuniItem.uid = umat.uid;
				this.$modal.hide("umatModal");
			});
		},
		autoFill() {
			this.umatItem.nama = this.$faker().name.findName();
			this.umatItem.tempat_lahir = this.$faker().address.city();
			this.umatItem.alamat = this.$faker().address.streetName();
			this.umatItem.tgl_lahir = "2000-01-01";
			this.umatItem.jk = "L";
			this.umatItem.suku = "Dayak";
			this.umatItem.keuskupan = "Keuskupan Sintang";
			this.umatItem.paroki = "Paroki Kristus Raja Katedral Sintang";
			this.umatItem.lingkungan_stasi = "Stasi Jerora 1";
			this.umatItem.kabupaten = "Sintang";
			this.umatItem.kecamatan = "Sintang  ";
			this.umatItem.desa = "Jerora Satu";
			this.umatItem.agama = "Katolik";
			this.umatItem.pekerjaan = "Konsultan";
			this.umatItem.pendidikan = "S1";
			this.umatItem.jurusan = "Teknik Infomatika";
			this.umatItem.nik = "61287318273";
			this.umatItem.nohp = "081255225454";
			this.umatItem.email = "Dayak@gmail.com";
			this.umatItem.gol_darah = "O";
			this.umatItem.aktivitas = "Warga Biasa";
			this.umatItem.profesi = [{ text: "Guru", value: "Guru" }];
			this.umatItem.keterampilan = [{ text: "Musik", value: "Musik" }];
			this.umatItem.status_kawin = "Menikah";
			this.umatItem.cacat_tubuh = "Tidak";

			this.umatKomuniItem.no_buku_lsc = "12345";
			this.umatKomuniItem.no_lsc = "54321";
			this.umatKomuniItem.tgl_komuni = "2020-04-03";
			this.umatKomuniItem.keuskupan_lsc = "Keuskupan Sintang";
			this.umatKomuniItem.paroki_lsc = "Paroki Katedral Kristus Raja Sintang";
		},
	},
};
</script>

<template>
	<div>
		<vue-fab
			mainBtnColor="#0071B3"
			:scrollAutoHide="false"
			size="big"
			:globalOptions="{ spacing: 50, delay: 0.05 }"
			icon="menu"
		>
			<fab-item
				@clickItem="handleSumbmit"
				:idx="0"
				title="Simpan"
				icon="save"
			/>
			<!-- <fab-item
				@clickItem="autoFill"
				:idx="1"
				title="Auto Fill"
				icon="input"
			/> -->
		</vue-fab>

		<Breadcrumbs main="Komuni" title="Form Komuni" />
		<!-- Container-fluid starts-->
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<form
						@submit.stop.prevent="onSubmit"
						v-if="isLoading"
						id="form-data"
					></form>
					<px-card>
						<div slot="with-padding">
							<h5 class="text-muted">Identitas Umat :</h5>
							<hr />
							<comp-umat
								@validate="validateUmat"
								:triggerValidation="trigger.umat"
							></comp-umat>
						</div>
					</px-card>
					<px-card>
						<div slot="with-padding">
							<h5 class="text-muted">Data Komuni :</h5>
							<hr />
							<comp-umat-komuni
								@validate="validateKomuni"
								:triggerValidation="trigger.komuni"
							></comp-umat-komuni>
						</div>
					</px-card>
				</div>
			</div>
		</div>

		<modal name="umatModal" width="80%" height="80%" :clickToClose="false">
			<template>
				<div class="myModal">
					<div class="row">
						<div class="col-md-12">
							<b-button-group class="btn-group">
								<b-button
									variant="danger"
									@click="onCancel()"
									v-b-tooltip.hover
									title="Batal"
									><i class="fa fa-close"></i> Batal</b-button
								>
							</b-button-group>
							<hr />
						</div>
						<div class="col-md-12">
							<comp-umat-modal @onRowClick="onRowClick" />
						</div>
					</div>
				</div>
			</template>
		</modal>
	</div>
</template>

<style scoped>
.myModal {
	padding: 20px;
	scroll-behavior: smooth;
}
::v-deep .vm--modal {
	overflow-y: auto;
}
.modal-card {
	margin: 0px;
}
</style>